import * as React from 'react';
export const IcCarShareRide = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.5 17c-.189 0-.375.038-.55.11L17.74 16 20 14.89c.174.072.361.11.55.11a1.5 1.5 0 10-1.44-1.9l-3 1.51a1.462 1.462 0 00-.55-.11 1.5 1.5 0 000 3c.189 0 .375-.038.55-.11l3 1.51A1.5 1.5 0 1020.5 17zm-14-9.31a1 1 0 011-.69h9.15a1 1 0 011 .68l.63 2.32h2.11l-1-2.95a3 3 0 00-2.84-2H7.41a3 3 0 00-2.85 2.02l-1.34 4.09A2 2 0 002 13v3a2 2 0 001 1.72V19a1 1 0 102 0v-1h7v-5a3 3 0 01.78-2h-7.4L6.5 7.69zM5.8 13c.195-.038.397-.017.58.06a1 1 0 11-1.3 1.3A1 1 0 015 13.8a1 1 0 01.8-.8z'
      fill='currentColor'
    />
  </svg>
);
